var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_628_5729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 2.66714H2.66634C2.31272 2.66714 1.97358 2.80762 1.72353 3.05767C1.47348 3.30772 1.33301 3.64685 1.33301 4.00048V13.3338C1.33301 13.6874 1.47348 14.0266 1.72353 14.2766C1.97358 14.5267 2.31272 14.6671 2.66634 14.6671H11.9997C12.3533 14.6671 12.6924 14.5267 12.9425 14.2766C13.1925 14.0266 13.333 13.6874 13.333 13.3338V8.66714M12.333 1.66714C12.5982 1.40193 12.9579 1.25293 13.333 1.25293C13.7081 1.25293 14.0678 1.40193 14.333 1.66714C14.5982 1.93236 14.7472 2.29207 14.7472 2.66714C14.7472 3.04222 14.5982 3.40193 14.333 3.66714L7.99967 10.0005L5.33301 10.6671L5.99967 8.00048L12.333 1.66714Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_628_5729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconDark);
export default __webpack_public_path__ + "static/media/Edit-icon-dark.dde1346645e5d259200f7be42418b602.svg";
export { ForwardRef as ReactComponent };